module.exports = __webpack_public_path__ + "static/img/shareImg2.8d4ad9b7.png";